import React, { useState, useEffect, Fragment } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import Post from "./Post";
import Header from "./Header";
import LeftCard from "./LeftCard";
import Footer from "./Footer";
import {
    Button,
    Alert,
    Card,
    CardImg,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardText,
} from "react-bootstrap";
import "./WordByWordUpdate.css";
import "./bubble.css";

import theme, { GlobalStyles } from './FilesUploderComponent/UI-Components/Theme'
import { AppBar, Link, Toolbar, Typography } from "@mui/material";
import { ThemeProvider } from '@mui/material'

function WordByWordUpdate() {
    const [item, setItems] = useState([]);
    const [message, setMessage] = useState('');
    const [qmessage, setQMessage] = useState('what is notice period?');
    const [displayedText, setDisplayedText] = useState('');
    const [loading, setLoading] = useState(false);

    const addItem = (qmessage, displayedText) => {
        setItems(prevItems => [...prevItems, { qmessage, displayedText }]);
    };

    // const updateTextWithDelay = async (text) => {
    //     const words = text.split(' ');

    //     for (const word of words) {
    //         await sleep(150); // Simulate delay
    //         setDisplayedText(prevText => prevText + ' ' + word);
    //     }
    // };
    const aupdateTextWithDelay = async (a_message) => {
        const words = a_message.split(' ');

        for (const word of words) {
            // Simulate a delay using setTimeout
            await sleep(150); // Adjust the delay time as needed

            // Update the displayedText state word by word
            setDisplayedText((prevText) => prevText + ' ' + word);

        }
        addItem(" " + qmessage, " " + a_message);
        setLoading(false);

    };

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        const interval = setInterval(() => {

            setDisplayedText(prevText => prevText.includes('Loading') ? prevText + '.' : prevText);

        }, 500);

        return () => clearInterval(interval);
    }, []);

    const handleSendMessage = () => {
        setMessage("");
        setLoading(true);
        setDisplayedText("Loading");
        fetch("http://157.173.222.203:8080/get_hr_response/?question=" + qmessage)
            .then(response => response.json())
            .then(data => {
                setMessage(" " + data.response);
                // updateTextWithDelay(data.response);
                // addItem(" " + qmessage, " " + data.response);
                setDisplayedText("");
                aupdateTextWithDelay(data.response);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    };

    const handleInputChange = (e) => {
        setQMessage(e.target.value);
        setDisplayedText('');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <div className='fillOutPage property'>
                <Header />
                <Container className="px-0">
                    <Row className="pt-2 pt-md-5 w-100 px-4 px-xl-0 position-relative">

                        <Card>
                            <Typography variant="h5" style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                                LLM based BOT Application for Human Resource  Domain

                            </Typography></Card>
                    </Row>
                    <Row className="pt-2 pt-md-5 w-100 px-4 px-xl-0 position-relative">
                        <div className="App">
                            {loading ? (<Card>
                                <div class="middle">
                                    {/* <p class="left-align">{" " + qmessage}</p> */}
                                    <p class="left-align">{" " + displayedText}</p>
                                </div>
                            </Card>) : (<Card>
                                <div className="center">
                                    <ul className="message-list">
                                        {item.map((item, index) => (
                                            <Fragment key={index}>
                                                <p className="right-align chat-bubble user">{item.qmessage}</p>
                                                <p className="left-align chat-bubble bot">{item.displayedText}</p>
                                            </Fragment>
                                        ))}
                                    </ul>
                                </div>
                            </Card>
                            )}

                            <Card>
                                <div className="center1">
                                    <div>
                                        <input
                                            className="resizedTextbox"
                                            type="text"
                                            id="fname"
                                            placeholder="Type your Question Here..."
                                            onChange={handleInputChange}
                                            value={qmessage}
                                            onKeyPress={handleKeyPress} // Listen for Enter key press
                                            name="fname" />
                                        <button className='bg-secondary send-btn resizedbutton' onClick={handleSendMessage}>Send</button>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </Row>
                </Container>
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default WordByWordUpdate;
